<button mat-icon-button class="subtle" (click)="sync()">
    <mat-icon>autorenew</mat-icon>
</button>
